import { css } from '@/styled-system/css';

export const cardsContainer = css({
  display: 'flex',
  gap: 'tighter',
  marginTop: 'tightest',
  overflowX: 'auto',
  overflowY: 'hidden',
  paddingBottom: 'tightest',
  scrollBehavior: 'smooth',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  '@media (prefers-reduced-motion: reduce)': {
    scrollBehavior: 'auto',
  },
});

export const card = css({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  paddingBlock: 'tighter',
  paddingInline: 'default',
  borderRadius: 'md',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  backgroundColor: 'bg.neutral',
  cursor: 'pointer',
  _hover: {
    backgroundColor: 'bg.softest',
    borderColor: 'brand.primaryHover',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const cardActive = css({
  borderColor: 'brand.primary',
  borderWidth: 'thick',
  backgroundColor: 'bg.action.soft.selected.default',
  _hover: {
    backgroundColor: 'bg.action.soft.selected.default',
    borderColor: 'brand.primary',
  },
});

export const cardIcon = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '600',
  width: '600',
  height: '600',
  flexShrink: 0,
});

export const cardContent = css({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const cardTime = css({
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
  lineHeight: 'body-sm',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const cardLabel = css({
  fontSize: 'body-xs',
  fontWeight: 'regular',
  color: 'text.subtle',
  lineHeight: 'body-xs',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const cardLoading = css({
  opacity: 0.5,
});

export const commuteHeader = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const commuteTitle = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const editButton = css({
  background: 'none',
  border: 'none',
  padding: 0,
  color: 'brand.primary',
  fontSize: 'body-sm',
  fontWeight: 'bold',
  cursor: 'pointer',
  _hover: {
    color: 'brand.primaryHover',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const destinationText = css({
  fontSize: 'body-xs',
  color: 'text.subtle',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
